module.exports = __webpack_public_path__ + "media/images/page/photo_manager-c50ccccf7cd067486e21128354169716.jpg";